@import '~less/global-variables';
@import '~less/layout/typography';

.tribes-header {
  padding-top: 130px;
  padding-bottom: 50px;
  margin-bottom: 30px;
  background-position: 50% 30%;
  .lead,
  h2 {
    text-shadow: none;
  }
  @media (min-width: @screen-sm-min) {
    padding-top: 260px;
    padding-bottom: 200px;
    margin-bottom: 40px;
  }
}

/**
 * Common styles for tribe elements
 */
.tribe-image {
  background-size: cover;
  background-position: 50% 50%;
  background-color: @brand-primary;
}

.tribe-actions {
  .btn {
    transition: all 0.2s ease-in-out;
    outline: none;
  }
}

.tribe-meta,
.tribe-label {
  color: #fff;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
}
.tribe-meta {
  .font-brand-regular();
}
.tribe-label {
  .font-brand-light();
}
